import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { inject } from "vue";
import * as autoOpenSearch from "@/components/Global/providedData/autoOpenSearch.ts";

export default function useBackButton() {
  const store = useStore();
  const route = useRoute();
  const router = useRouter();

  const { disableAutoOpenSearch, enableAutoOpenSearch, shouldAutoOpenSearch } =
    inject(autoOpenSearch.key, autoOpenSearch.defaultApi);

  function goBack() {
    if (route.query.fromSearch) {
      enableAutoOpenSearch();
      router.back();
      return;
    }

    if (shouldAutoOpenSearch.value) {
      disableAutoOpenSearch();
    }

    if (route.query.returnToCategoryId) {
      router.push({
        name: "Category",
        params: {
          styleid: store.getters.getStyleID,
          categoryID: route.query.returnToCategoryId,
        },
      });

      return;
    }

    const parentCatID = store.getters.getStoreVar(
      route.name,
      "page",
      "nonCMS",
      "parentCategoryID"
    );

    if (route.query.fromHome || route.query.returnHome) {
      router.push({
        name: "Home",
        params: { styleid: store.getters.getStyleID },
      });
      return;
    }

    switch (route.name) {
      case "BulkCategoryEditor":
        router.push({
          name: "Category",
          params: {
            styleid: store.getters.getStyleID,
            categoryID: route.params.categoryID,
          },
        });
        break;
      case "BulkRecordItemsEditor":
        router.push({
          name: "Category",
          params: {
            styleid: store.getters.getStyleID,
            categoryID: route.params.categoryID,
          },
        });
        break;
      case "Categories":
        router.push({
          name: "Home",
          params: { styleid: store.getters.getStyleID },
        });
        break;
      case "SubCategories":
        if (parentCatID) {
          router.push({
            name: "SubCategories",
            params: {
              styleid: store.getters.getStyleID,
              categoryID: parentCatID,
            },
            query: { backButton: true },
          });
        } else {
          router.push({
            name: "Categories",
            params: {
              styleid: store.getters.getStyleID,
            },
            query: { backButton: true },
          });
        }
        break;
      case "Category":
        if (parentCatID) {
          router.push({
            name: "SubCategories",
            params: {
              styleid: store.getters.getStyleID,
              categoryID: parentCatID,
            },
            query: { backButton: true },
          });
        } else {
          router.push({
            name: "Categories",
            params: {
              styleid: store.getters.getStyleID,
            },
            query: { backButton: true },
          });
        }

        break;
      case "Person":
        router.push({
          name: "Category",
          params: {
            styleid: store.getters.getStyleID,
            categoryID: route.params.categoryID,
          },
          query: { backButton: true },
        });
        break;
      default:
        router.push({
          name: "Home",
          params: { styleid: store.getters.getStyleID },
        });
    }
  }

  return {
    goBack,
  };
}
